import React, { useEffect, useState, useMemo } from "react";
import {
  Box,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Dialog,
  DialogTitle,
} from "@mui/material";
import SectionTitle from "../../components/sectionTitle";
import { postWebService } from "../../helpers/server";
import { validateInputLength } from "../../helpers/utils";
import { useStyles } from "./indexStyles";
import { withStyles } from "@mui/styles";

const NegativePincodeTable = ({
  classes: {},
  onClose,
  onClickHandler,
  modal,
  modalKey = "pincode",
  toggleModal = () => {},
}) => {
  const [pincodes, setPincodes] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchPincodes = async () => {
      setLoading(true);
      try {
        const response = await postWebService(`negetivepincodes.php`, {});
        const data = response.data;

        setPincodes(data.data || []);
      } catch (error) {
        setPincodes([]);
      } finally {
        setLoading(false);
      }
    };
    fetchPincodes();
  }, []);

  const filteredPincodes = useMemo(
    () =>
      pincodes.filter((item) =>
        item.pincode.toString().includes(search.trim())
      ),
    [pincodes, search]
  );

  return (
    <Dialog
      onClose={(event, reason) => onClose(event, reason, modalKey)}
      aria-labelledby="simple-dialog-title"
      open={modal.pincode}
      maxWidth={"lg"}
      fullScreen={true}
    >
      {/* <DialogTitle id="simple-dialog-title">
        <SectionTitle
          backButton={true}
          color={"secondary"}
          onClickHandler={() => toggleModal("pincode", false)}
          title={"Negative Pin Codes List"}
        />
      </DialogTitle> */}
      <Box p={1}>
        <SectionTitle
          backButton={true}
          // color={"secondary"}
          onClickHandler={() => toggleModal("pincode", false)}
          title={"Non-Serviceable Pincodes"}
        />
        <Box mt={2} mb={1}>
          <TextField
            name="pincode"
            type="number"
            label="Enter your pincode"
            variant="outlined"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onInput={validateInputLength}
            fullWidth
          />
        </Box>
        {loading ? (
          <Box display="flex" justifyContent="center" mt={2}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer
            component={Paper}
            sx={{ maxHeight: "80vh", overflowY: "auto", width: "100%" }}
          >
            <Table size="small">
              {filteredPincodes.length > 0 && (
                <>
                  {/* <TableHead>
                    <TableRow>
                      <TableCell colSpan={3}>
                        <Box>
                          <Typography variant="body2">
                            Total Non-Serviceable Pincodes:{" "}
                            <b>{filteredPincodes.length}</b>
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  </TableHead> */}
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Typography variant="body1">Location</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body1">Pincode</Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                </>
              )}

              <TableBody>
                {filteredPincodes.map((row, idx) => (
                  <TableRow
                    key={row.pincode}
                    sx={{
                      backgroundColor:
                        idx % 2 === 0 ? "background.paper" : "grey.100", // Use theme colors for consistency
                    }}
                  >
                    <TableCell>
                      <Typography variant="body2">
                        {row.city || row.district}
                      </Typography>
                      <Typography variant="body2">({row.state})</Typography>
                    </TableCell>
                    <TableCell>{row.pincode}</TableCell>
                  </TableRow>
                ))}
                {search && filteredPincodes.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      <Box>
                        <Typography
                          variant="body2"
                          color="green"
                          sx={{ color: "green" }}
                        >
                          Congratulations! You are eligible to proceed with this
                          pincode.
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
                {search && filteredPincodes.length > 0 && (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      <Box>
                        <Typography
                          variant="body2"
                          color="warning"
                          sx={{ color: "red" }}
                        >
                          Oops! You are not eligible to proceed with this
                          pincode.
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Dialog>
  );
};

export default withStyles(useStyles, { withTheme: true })(NegativePincodeTable);
